import { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'

import useOnClickOutside from '../../hooks/useOnClickOutside'

import { joinClassNames } from '../../utils/styles'
import styles from './popup.module.scss'

interface IPopupProps {
    isOpen: boolean
    closePopup: () => void
    children: React.ReactNode
    className?: string
}

function Popup(props: IPopupProps) {
    const { isOpen, closePopup, children, className } = props

    const childrenRef = useRef<HTMLDivElement>(null)

    useOnClickOutside(childrenRef, closePopup)

    useEffect(() => {
        if (document.getElementById('popup')) return
        const wrapperElement = document.createElement('div')
        wrapperElement.setAttribute('id', 'popup')
        document.body.appendChild(wrapperElement)
    }, [])

    if (!isOpen) return null

    return createPortal(
        <div className={joinClassNames(styles.popup, className)}>
            <div ref={childrenRef}>{children}</div>
        </div>,
        document.getElementById('popup') as HTMLElement
    )
}

export default Popup
